import styled  from 'styled-components';

const SlipWrapper = styled.div`
  background-color: white !important;
  border: 1px solid black !important;
  margin-bottom: 0px !important;
  > div {
    @media (max-width: 1224px) {
      flex-direction: column;
      text-align: -webkit-center;
    }
    .ticket-image {
      @media (max-width: 1224px) {
        margin-right: 0 !important;
      }
    }
  }
`;

export default SlipWrapper;